import { render, staticRenderFns } from "./CodeBlockControl.vue?vue&type=template&id=612e97ce&"
import script from "./CodeBlockControl.vue?vue&type=script&lang=ts&"
export * from "./CodeBlockControl.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports